<wms-dialog-header (onClose)="closeModal()" title='{{dialogTitleRestore}}'></wms-dialog-header>
<wms-dialog-body>
    <form enctype="multipart/form-data" name="projectImportForm" class="wm-form">
        <wms-message [scopeDataset]="message" hideclose="true"></wms-message>
        <div class="form-group app-composite-widget clearfix" *ngIf="reImport">
            <p class="app-dialog-message col-md-12">
                {{locale.LABEL_PROJECTS_RESTORE_MESSAGE}}
            </p>
        </div>
        <div class="form-group app-composite-widget clearfix restore-options" *ngIf="restore">
            <label class="import-restore-option">{{locale.LABEL_PROJECTS_RESTORE}}:</label>
            <label>
                <label class="radio-inline ng-binding">
                    <input type="radio" [disabled]="processing" name="restoreProject"
                        (ngModelChange)="setRestoreFrom('snapshot')" [(ngModel)]="restoreFrom" value="snapshot" />
                    {{locale.LABEL_PROJECTS_FROM_SNAPSHOT}}
                </label>
                <label class="radio-inline ng-binding">
                    <input type="radio" [disabled]="processing" name="restoreProject"
                        (ngModelChange)="setRestoreFrom('zip')" [(ngModel)]="restoreFrom" value="zip" />
                    {{locale.LABEL_PROJECTS_FROM_ZIP}}
                </label>
            </label>
        </div>
        <div class="form-group app-composite-widget clearfix" *ngIf="!reImport">
            <label class="control-label app-label col-md-3">
                {{locale.LABEL_PROJECT_NAME}}:
            </label>
            <div class="col-md-9">
                <input type="text" maxlength="32" autocomplete="off" class="form-control app-textbox project-name"
                    name="packageDisplayName" [readOnly]="processing" [(ngModel)]="projectData.displayName"
                    (ngModelChange)="validateProjectName()" (keypress)="initiateImport($event, 'projectImportForm')" />
            </div>
        </div>
        <div class="form-group app-composite-widget clearfix" *ngIf="!reImport">
            <label class="control-label app-label col-md-3">
                {{locale.LABEL_REPO_NAME}}:
            </label>
            <div class="col-md-6">
                <span class="form-control read-only-input" name="packageName">{{projectData.name}}</span>
            </div>
        </div>
        <div class="form-group app-composite-widget restore-message clearfix" *ngIf="reImport && restoreFrom !== 'zip'">
            <p class="app-dialog-message col-md-12">
                {{locale.MESSAGE_PROJECTS_RESTORE}}
            </p>
        </div>
        <div class="form-group app-composite-widget project-restore clearfix" *ngIf="restoreFrom === 'zip'">
            <label class="control-label app-label col-md-3 import-restore-option">
                {{locale.LABEL_FILE_UPLOAD_FILE_ZIP}}
            </label>
            <div class="col-md-8" [ngClass]="{'processing-file' : processing}">
                <wms-file-upload id="import-project-file-upload" name='wmfile' [acceptType]="'.zip'" model='fileDetails'
                    (onChoose)="getProjectName($event)"></wms-file-upload>
            </div>
        </div>
        <input type="hidden" name="targetIdentifierId"
            value="{{projectService ? projectService.getProjectId() : studioProjectId}}" *ngIf="reImport" />
    </form>
</wms-dialog-body>
<wms-dialog-footer>
    <button [disabled]="processing" name="wm-import-project-cancel" (click)="confirmImportActionCancel()"
        class="btn button-secondary" title="{{locale.LABEL_CANCEL}}">{{locale.LABEL_CANCEL}}</button>
    <button
        [disabled]="(restoreFrom === 'zip' && (!isProjectValid || !projectData.zipname)) || processing || disableImportBtn"
        name="wm-import-project-ok" (click)="importProject('projectImportForm')" class="btn button-primary"
        title="{{(restoreFrom === 'zip') ? locale.LABEL_IMPORT : locale.LABEL_OK}}">{{(restoreFrom === 'zip') ?
        locale.LABEL_IMPORT : locale.LABEL_OK}}</button>
</wms-dialog-footer>